import { render, staticRenderFns } from "./SubmitAbnormalDialog.vue?vue&type=template&id=bc6d0c58&"
import script from "./SubmitAbnormalDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubmitAbnormalDialog.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports